import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetTeamQuery,
  GetTeamQueryVariables,
} from "./GetTeam.generated";

const GET_TEAM: TypedDocumentNode<
  GetTeamQuery,
  GetTeamQueryVariables
> = gql`
  query getTeam($uuid: String) {
    team(uuid: $uuid) {
      uuid
      name
      createdAt
      organization {
        uuid
        name
        allowsDirectMemberAdd
        emailDomain
        emailDomainSecondary
        emailDomainTertiary
        isManualBilling
        stripeCustomerId
      }
      users {
        uuid
        firstName
        lastName
        email
        numAppointmentsUsed
        account {
          uuid
          isSubscribed
        }
      }
    }
  }
`;
export default GET_TEAM;
